import red from '@mui/material/colors/red';
import { defaultTheme } from 'react-admin';
import { deepmerge } from '@mui/utils';

const themes = {
  common: {
    mode: 'light',
    error: red,
    contrastThreshold: 3,
    tonalOffset: 0.2,
  },
  damago: {
    primary: { main: '#1F6099' },
    secondary: { main: '#000' },
  },
  bawi: {
    primary: { main: '#F38336', contrastText: '#fff' },
    secondary: { main: '#69f', contrastText: '#fff' },
  },
  agm: {
    primary: { main: '#5688f5', contrastText: '#fff' },
    secondary: { main: '#FDD155', contrastText: '#fff' },
  },
  com: {
    primary: { main: '#1F6099' },
    secondary: { main: '#000' },
  },
};

export const getTheme = (name) => {
  const palette = { ...themes.common, ...themes[name] };
  const theme = deepmerge(defaultTheme, {
    palette: palette,
  });

  return theme;
};
